module.exports = __webpack_public_path__ + "static/media/phone.0715ab57.svg";